import React, { useState, useEffect } from "react";
import axios from "axios";
import { CalendarCheck, AlertTriangle, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (d) => (d ? new Date(d).toLocaleDateString("de-DE") : "–");

function SiteRow({ r }) {
  return (
    <div className="flex items-start justify-between gap-3 py-2 border-t border-white/5 text-sm" data-testid={`booking-check-${r.key}`}>
      <div>
        <div className="font-semibold">{r.name}</div>
        <div className="text-xs text-eb-muted">{r.arrival ? `Testsuche ${fmt(r.arrival)} – ${fmt(r.departure)} · 2 Erw.` : "kein Testtermin"}</div>
        {!r.ok && <div className="text-xs text-rose-300 mt-1" data-testid={`booking-check-${r.key}-reason`}>{r.reason}</div>}
      </div>
      <span className={`text-xs font-semibold whitespace-nowrap ${r.ok ? "text-emerald-400" : "text-rose-400"}`} data-testid={`booking-check-${r.key}-status`}>
        {r.ok ? `✓ ${r.categories} Kategorie(n) buchbar` : "keine Unterkunft"}
      </span>
    </div>
  );
}

export function BookingCheckCard() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/booking-check`).then((r) => setD(r.data)).catch(() => {}); }, []);
  const run = async () => {
    setBusy(true);
    try { setD((await axios.post(`${API}/booking-check/run`)).data); } finally { setBusy(false); }
  };
  const has = d && d.results;
  return (
    <div className={`card ${has && !d.ok ? "!border-rose-500/60" : ""}`} data-testid="booking-check-card">
      <div className="flex items-center justify-between gap-3 mb-1">
        <div className="flex items-center gap-2">
          {has && !d.ok ? <AlertTriangle size={18} className="text-rose-400" /> : <CalendarCheck size={18} className="text-emerald-400" />}
          <div>
            <div className="overline">Täglicher Buchungs-Check · 6 Uhr</div>
            <div className="font-heading font-bold" data-testid="booking-check-summary">
              {!has ? "Noch nicht gelaufen" : d.ok ? "Online-Buchung funktioniert" : "Achtung: Online-Buchung findet keine Unterkunft"}
            </div>
          </div>
        </div>
        <button className="btn !py-1 !px-2 text-xs" onClick={run} disabled={busy} data-testid="booking-check-run-btn">
          <RefreshCw size={12} className={busy ? "animate-spin" : ""} /> {busy ? "prüft…" : "Jetzt prüfen"}
        </button>
      </div>
      {has && d.results.map((r) => <SiteRow key={r.key} r={r} />)}
      {has && <div className="text-[11px] text-eb-muted mt-2" data-testid="booking-check-at">Zuletzt: {new Date(d.at).toLocaleString("de-DE")} · bei Problemen Mail an info@schwalbennest-ruegen.de</div>}
    </div>
  );
}
